module.exports = "<h2 md-dialog-title>{{title}}</h2>\n<div md-dialog-content>{{message}}</div>\n<div md-dialog-actions>\n  <button md-button (click)=\"dialogRefWarning.close('1')\" color=\"accent\">Close</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/mobile/warning.html
// module id = ../../../../../src/app/pages/mobile/warning.html
// module chunks = 39